import React from 'react';
import PropTypes from 'prop-types';
import BaseIcon from '../../utils/BaseIcon';

const AgentGraphicIcon = props => {
  const iconFill = 'currentColor';
  return (
    <BaseIcon {...props}>
      <path fill={iconFill} fillRule="evenodd" d="M12.49 1.018a4.982 4.982 0 00-5.295 4.476.5.5 0 01-.995-.099 5.983 5.983 0 118.869 5.819.5.5 0 01-.488-.873 4.983 4.983 0 00-2.091-9.323zM5.177 6.986a.5.5 0 00-1 0v.499a4.488 4.488 0 004.045 4.466 1.996 1.996 0 10.012-1.005 3.488 3.488 0 01-3.057-3.461v-.499zm3.987 4.486a.995.995 0 111.99 0 .995.995 0 01-1.99 0zm3.04 3.446a5.707 5.707 0 013.443 1.125l-3.403 3.829-3.403-3.829a5.707 5.707 0 013.363-1.125zm-.007-1a6.706 6.706 0 00-4.022 1.375l-.923-1.037a.5.5 0 00-.702-.044 10.469 10.469 0 00-4.667 9.308.5.5 0 00.999-.055 9.469 9.469 0 013.92-8.212l4.942 5.561v2.493a.5.5 0 101 0v-2.493l4.943-5.56a9.468 9.468 0 013.92 8.211.5.5 0 00.998.056 10.468 10.468 0 00-4.667-9.31.5.5 0 00-.702.045l-.922 1.037a6.707 6.707 0 00-4.117-1.375z" clipRule="evenodd"/>
    </BaseIcon>
  );
};

AgentGraphicIcon.displayName = 'AgentGraphicIcon';

AgentGraphicIcon.propTypes = {
  theme: PropTypes.object,
  size: PropTypes.oneOfType([PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"]), PropTypes.number]),
  fill: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
}

AgentGraphicIcon.defaultProps = {
  size: 48
};

AgentGraphicIcon.displayName = 'AgentGraphicIcon';
AgentGraphicIcon.iconName = 'Agent';

export default AgentGraphicIcon;
